import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const requests = new Map();

// Only public presentation data. Never cache carts, orders, auth or inventory.
export function publicData(path, ttl = 30000) {
  const cached = requests.get(path);
  if (cached && cached.expires > Date.now()) return cached.promise;
  const bootstrap = window.__ogBootstrap?.[path];
  if (bootstrap) delete window.__ogBootstrap[path];
  const promise = (bootstrap || axios.get(`${API}/${path}`).then(r => r.data))
    .catch(error => { requests.delete(path); throw error; });
  requests.set(path, { promise, expires: Date.now() + ttl });
  return promise;
}